import { useQuery } from 'react-query';

// our api urls
import { getLenderListUrl } from 'shared/api-urls';

// our axios
import axiosInstance from 'services/API/API';

function useGetLenderList() {
	return useQuery('LENDERS_LIST', async () => {
		const response = await axiosInstance.get(getLenderListUrl);
		return response.data;
	});
}

export default useGetLenderList;
